import { AibTransactionStatusResponse } from './TransactionStatusResponse';

interface OrderBilling {
  name: string;
  // You can add other billing details like address, email, etc. here if needed.
}

export interface OrderResponse {
  type: 'orderResponse';
  clientRequestId: string;
  apiTraceId: string;
  orderId: string;
  billing: OrderBilling;
  transactions: Omit<AibTransactionStatusResponse, 'clientRequestId' | 'apiTraceId'>[];
}
